<template>
    <div>
        <div style="display: none;">
            <input type="file" :name="name" :disabled="disabled" ref="fileInput" :accept="accepted" @change="onFilesChange($event)" :multiple="multiple">
        </div>

        <div>
            <div @dragenter.prevent.stop
                 @dragleave.prevent.stop
                 @dragover.prevent.stop
                 @drop.prevent.stop="dropFiles"
                 @dragstart.prevent.stop
                 @dragend.prevent.stop
            >
                <slot name="upload">
                    <div class="labels-supported-format mb-4">{{formattedMimes}}</div>
                    <button class="btn btn-secondary w-100 text-uppercase upload-button" @click.prevent.stop="inputClick">
                        <i class="las la-cloud-upload-alt mr-2"></i>  Upload file
                    </button>
                </slot>
            </div>

            <slot name="files">
                <template v-if="Object.values(files).length > 0">
                    <div class="mt-4 mb-2 fw-600 fs-3">Uploaded files:</div>
                    <div class="d-flex flex-column gap-3">
                        <div class="uploaded-files" v-for="(file, index) in files">
                            <div class="d-flex align-items-center justify-content-between gap-2">
                                <span class="thumbnail-title">{{file.original_name ? file.original_name : file.file_name}}</span>
                                <button class="btn btn-sm p-0" type="button" :disabled="disabled" @click="removeFileByKey(index)">
                                    <i class="las la-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </slot>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        props: {
            name: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            mediaOptions: {
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            uploadLink: {
                type: String,
                required:false,
                default: ''
            },
            existingFiles: {
                type: Array,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                files: {},
                errors: [],
                image_mime_types: [
                    'image/apng',
                    'image/avif',
                    'image/gif',
                    'image/png',
                    'image/jpeg',
                    'image/svg+xml',
                    'image/webp',
                ],
                loading_status_data: {},
                key: 0,
            };
        },
        mounted() {
            document.addEventListener('drop', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
            document.addEventListener('dragover', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
            this.processExistingFiles();
        },
        computed: {
            accepted: function () {
                let str = '';

                if (null !== this.mediaOptions.mimes) {
                    str+=this.mediaOptions.mimes;
                }

                if (null !== this.mediaOptions.mimeTypes) {
                    if (str.length !== 0) {
                        str+=',';
                    }

                    str+=this.mediaOptions.mimeTypes;
                }

                return str;
            },
            formattedMimes: function () {
                return (this.mediaOptions.mimes).replaceAll('.',' ').toUpperCase();
            }
        },
        methods: {
            filePreview(file)
            {
                if (typeof file.file !== 'undefined' && null !== file.file) {
                    if(this.isImage(file)) {
                        return URL.createObjectURL(file.file);
                    }
                }

                if(this.isImage(file)) {
                    return this.$fileLink(file);
                }

                return "/images/file_icon.png";
            },
            fileShowLink(file) {
                if (typeof file.file !== 'undefined' && null !== file.file) {
                    return URL.createObjectURL(file.file);
                }

                return this.$fileLink(file);
            },
            isImage (file) {
                var app = this;
                if (typeof file.type !== 'undefined' && app.image_mime_types.includes(file.type)){
                    return true;
                }
                if (typeof file.mime_type !== 'undefined' && app.image_mime_types.includes(file.mime_type)){
                    return true;
                }
                return false;
            },
            onFilesChange()
            {
                let files = this.$refs.fileInput.files;
                for (let i = 0; i < files.length; i++ ) {
                    this.addNewFile(files[i]);
                }
                this.$refs.fileInput.value = null;
            },
            addNewFileNoRoute(file) {
                let app = this;
                let generatedFile = {
                    file: file,
                    original_name: file.name,
                    file_name: file.name,
                    url:  file.url,
                    type: file.type,
                    loading: true,
                    encoded_file: null
                };

                this.key += 1;
                let file_key = this.key;

                Vue.set(app.files, file_key, generatedFile);
                this.emitFiles();

                this.getBase64(file)
                    .then(data => {
                        generatedFile.loading = false;
                        generatedFile.encoded_file = data;
                        Vue.set(app.files, file_key, generatedFile);
                    })
                    .catch(error => {
                        app.removeFileByKey(file_key);
                        app.addError(error);
                    }).finally(() => {
                        this.emitFiles();
                    });
            },
            async getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                });
            },
            addNewFile(file) {
                var app = this;
                app.clearErrors();

                if (app.mediaOptions !== null) {
                    if (app.mediaOptions.maxFileCount !== null && Object.keys(app.files).length >= app.mediaOptions.maxFileCount) {
                        this.addError('Maximum uploaded file count has been reached');
                        return;
                    }

                    if (app.mediaOptions.maxFileSize !== null && file.size >= app.mediaOptions.maxFileSize * 1000000) {
                        this.addError('The file you are trying to upload is too large');
                        return;
                    }
                }

                let has_duplicate_error = false;
                Object.keys(app.files).forEach((existingFileKey) => {
                    if(app.files[existingFileKey].name === file.name) {
                        has_duplicate_error = true;
                    } else if (typeof app.files[existingFileKey].file_name !== 'undefined' && app.files[existingFileKey].file_name !== null) {
                        if(app.files[existingFileKey].file_name === file.name) {
                            has_duplicate_error = true;
                        }
                    }
                });

                if (has_duplicate_error) {
                    this.addError('A file with that name already exists');
                    return ;
                }

                if (this.uploadLink === '') {
                    this.addNewFileNoRoute(file);
                    return;
                }

                let generatedFile = {
                    file: file,
                    original_name: file.name,
                    file_name: file.name,
                    url:  file.url,
                    type: file.type,
                    loading: true,
                };

                this.key += 1;
                let file_key = this.key;

                Vue.set(this.files, file_key, generatedFile);
                this.emitFiles();

                let formData = new FormData();
                formData.append('file', file);

                axios.post(app.uploadLink, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content
                    }
                }).then(function (response) {
                    generatedFile.original_name = response.data.original_name;
                    generatedFile.file_name = response.data.name;
                    generatedFile.loading = false;
                    Vue.set(app.files, file_key, generatedFile);
                    app.$emit('file_uploaded', response.data);
                }).catch(function (error) {
                    let text = '';

                    if(error.response.data.errors && error.response.data.errors.file) {
                        error.response.data.errors.file.forEach(function (message) {
                            text += message + '<br>';
                        });
                    }

                    app.removeFileByKey(file_key);
                    app.addError(text);
                }).finally(function () {
                    app.emitFiles();
                });
            },
            dropFiles(event) {
                return;
                // untested
                // if(this.disabled) {
                //     return;
                // }
                // var app = this;
                // for (var i = 0; i < event.dataTransfer.files.length; i++) {
                //     app.addNewFile(event.dataTransfer.files[i]);
                // }
            },
            inputClick(event) {
                if(this.disabled) {
                    return;
                }
                this.$refs.fileInput.click();
            },
            emitFiles() {
                var app = this;
                let array = [];
                Object.keys(app.files).forEach((object_key) => {
                    app.files[object_key].file_link = app.fileShowLink(app.files[object_key]);
                    array.push(app.files[object_key]);
                });
                app.$emit('files', JSON.parse(JSON.stringify(array)));
            },
            removeFileByKey(key) {
                console.log('asd', key, this.files);
                Vue.delete(this.files, key);
                this.emitFiles();
            },
            addError(message) {
                this.errors.push(message);

                this.$emit('onError', message);
            },
            clearErrors() {
                this.errors = [];

                this.$emit('onError', '');
            },
            generateLinkToFile(file) {
                return URL.createObjectURL(file.file);
            },
            processExistingFiles() {
                var app = this;
                Vue.set(app, 'files', {});

                if (app.existingFiles !== null && Array.isArray(app.existingFiles)) {
                    app.existingFiles.forEach((item) => {
                        app.key += 1;
                        Vue.set(app.files, app.key, JSON.parse(JSON.stringify(item)));
                    });
                }
                app.emitFiles();
            },
        },
        watch: {
            existingFiles: function () {
                this.processExistingFiles();
            }
        }
    }
</script>
